const monthName = ( month ) => {

    const meses = {
        1: "Gener",
        2: "Febrer",
        3: "Març",
        4: "Abril",
        5: "Maig",
        6: "Juny",
        7: "Juliol",
        8: "Agost",
        9: "Setembre",
        10: "Octubre",
        11: "Novembre",
        12: "Desembre"
    }
    return meses[month];
};

export default monthName;